import React, { FunctionComponent } from 'react';

import { SvgProps, propsHelperRem } from '@/shared/lib/propsHelper';

export const UnbookmarkIcon: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(2.4, 2.4, props)}>
        <path d="M5.5 3.5h13V21L12 17.45 5.5 21V3.5Z" />
    </svg>
);
